import { useTasks } from '@/hook/useTasks';
import { ClipboardCheckIcon, ClipboardIcon } from 'lucide-react';
import React, { useState } from 'react';

interface TaskFormData {
    id: number,
    description: string,
    businessId: number,
    userName:string,
    activityTypesId: number,
    userId: number,
    prevision: Date,
    iniciatedAt:Date,
    notification: boolean,
    observation: string,
    priority: number,
    situation: number,
    done: string,
    companyId: number,
    conclusionAt: Date | null,
    activityType: string,
    userWhoAdds: string,
  }

interface TaskInterface{
    dataTaskEdit: any;
    isCompleted: boolean;
    tasks:TaskFormData[] | [];
}

const TaskContext = React.createContext<any>({} as TaskInterface);

export const TaskProvider: React.FC<any> = ({ children }) => {

  const [ dataTaskEdit, setDataTaskEdit ] = useState();
  const [isCompleted, setIsCompleted] = useState(false);
  const [tasks, setTasks] = useState<TaskFormData[]>([]);
  const [cardTitle, setCardTitle] = useState('Tarefa Adicionada por');
  const [icon, setIcon] = useState(<ClipboardIcon size={14} color='white' />);
  const [bgColor, setBgColor] = useState('bg-indigo-200'); 

  return(
    <TaskContext.Provider value={{dataTaskEdit, setDataTaskEdit, tasks, setTasks, isCompleted, setIsCompleted, bgColor, setBgColor, icon, setIcon, cardTitle, setCardTitle}}>{children}</TaskContext.Provider>
  );

};

export const useTaskContext = () => React.useContext(TaskContext);
